import type { Data } from '@wix/thunderbolt-becky-types'
import { CompNodes } from '@wix/thunderbolt-catharsis'
import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import type { CompNodesProvider } from './types'
import { CatharsisFeatureSymbol } from './symbols'

export const FeaturesCompNodesProvider = withDependencies(
	[multi(CatharsisFeatureSymbol)],
	(features): CompNodesProvider => {
		const res = features.reduce(
			(acc, feature) => {
				acc.usedDataMaps.push(...feature.usedDataMaps)
				acc.componentNodes[feature.name] = feature.configCompNode
				if (feature.masterPageConfigCompNode) {
					acc.componentNodes[`${feature.name}MasterPage`] = feature.masterPageConfigCompNode
				}
				Object.assign(acc.componentNodes, feature.intermediateNodes)
				feature.shouldLoadCompNode &&
					(acc.componentNodes[`${feature.name}ShouldLoad`] = feature.shouldLoadCompNode)
				return acc
			},
			{
				componentNodes: {} as CompNodes<any>,
				usedDataMaps: [] as Array<keyof Data>,
			}
		)
		return {
			getCompNodes: () => res.componentNodes,
			getUsedDataMaps: () => res.usedDataMaps,
		}
	}
)
